import * as queryString from 'query-string'
import './cert.css'
import ReactToPrint, {useReactToPrint} from "react-to-print";
import React, {useEffect, useRef} from "react";
import {httpClient} from "../../service";
import {ActionResult, defaultTag, HttpMethod} from "../../model";
import {useAsync} from "react-async";
import LoadingHtml from "../../shared/Loading";
import ErrorPage from "../../shared/ErrorPage";
import ComponentToPrint from "./ComponentToPrint";


const TourCertificationComponent = (props: any) => { // 추가
    const componentRef = useRef<any>();
    const location = props.location;
    const search = queryString.parse(location.hash);
    const couponCode = search.code;
    const token = search.token;

    /*  const couponCode = 120;
      const token = `eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMDIiLCJyb2xlcyI6W10sInVzZXJEYXRhIjoie1wibG9naW5JZFwiOlwiMTE4Mjc5MTE5MDYwNTQ0MDg2NTIxXCIsXCJuYW1lXCI6XCJhbm9ueW1vdXNcIixcIm1lbWJlclR5cGVcIjpcIkdvb2dsZVwifSIsImlhdCI6MTYyNTE4NTQyMiwiZXhwIjoxNjU2NzIxNDIyfQ.j-0Wtg9EBTt5Wygtx3asoB8LglHEpxAbkYnTXuIRWMqBg9KdXUy71cYYYE4qlZ9ggDnDuLHQNEj-zEe3hj1nDQ`;*/
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });
    const onPrint = () => {
        console.log('print');
    }
    /*console.log(`couponCode=${couponCode},token=${token}`);
    const printPDF = () => {
        const domElement = document.getElementById("print-area");
        html2canvas(domElement as HTMLElement, {

        }).then(canvas => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPdf();

            pdf.addImage(imgData, "JPEG", 10, 10,500,500);
            pdf.save(`${couponCode}.pdf`);
        });
    };*/


    const url = `members/coupons/tour/cert/${couponCode}`;
    const options = {
        promiseFn: httpClient,
        method: HttpMethod.GET,
        url,
        authorization: `Bearer ${token}`
    };
    /*useEffect(() => {

    }, [search]);*/

    /* const loadImage = (tourNm:string)=> {
         const node:HTMLElement | null=document.getElementById('print-area');
         console.log(`loadImage function load`);
         if (node) {
             console.log('print area exists');
             setTimeout(function () {
                 htmlToImage.toPng(node).then((dataUrl) => {
                     const img = new Image();
                     img.crossOrigin="Anonymous";
                     img.src = dataUrl;
                     const link = document.createElement('a');
                     link.download = `${tourNm}.png`;
                     link.href = dataUrl;
                     document.body.appendChild(img);
                     //link.click();

                 }).catch(e => {
                     console.error(e);
                 });
             }, 100);

         } else {
             console.error('print area not exists');
         }
     };*/

    const {data: act, error, isLoading} = useAsync<ActionResult>(options);

    useEffect(() => {
        var id=document.getElementById('print-button');
        if(id) {
            id.click();
        }
    });
    if (isLoading) return <LoadingHtml/>;
    if (error) {
        console.error('error:' + error);
        return <ErrorPage/>;
    }
    if (!act) return null;
    if (act.result) {
        const that: any = this;
        return (
            <div>
                <ReactToPrint copyStyles={true} content={() => componentRef.current} trigger={()=><button id='print-button'>Print</button>}/>
                <ComponentToPrint data={act.data} ref={componentRef} />
            </div>
        )

        {/*return  <TourCertPrintComponent data={act.data} parentCallback={printPDF}></TourCertPrintComponent>*/
        }
    } else {
        return <ErrorPage action={act}/>
    }
}


export default TourCertificationComponent;
